exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host > app-modal .field {\n  display: block;\n}\n:host > app-modal .field._is-required > .caption::before {\n  content: \"*\";\n  position: absolute;\n  right: -6px;\n  top: 0;\n  font-size: 11px;\n  color: #f75f5f;\n}\n:host > app-modal .field > .caption {\n  --height: 16px;\n  position: relative;\n  height: var(--height);\n  line-height: var(--height);\n  font-size: 14px;\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text);\n}\n:host > app-modal .field > input {\n  --height: 48px;\n  width: 100%;\n  height: var(--height);\n  margin-top: 8px;\n  padding-left: 12px;\n  padding-right: 12px;\n  line-height: var(--height);\n  font-size: 16px;\n  color: var(--color-text);\n  background-color: #ffffff;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px var(--color-divider) inset;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/edit-subsection-modal/edit-subsection-modal.component.less
// module id = ../../../../../src/app/edit/sections-panel/edit-subsection-modal/edit-subsection-modal.component.less
// module chunks = main